// extracted by mini-css-extract-plugin
export default {"container":"MyInfo_container__2ND2V","titleBar":"MyInfo_titleBar__Nuh6i","content":"MyInfo_content__XKVM-","error":"MyInfo_error__ob-Zg"};